import { RootState } from '../../rootReducer';

export const bookmarksSelectors = {
  getBookmarks: (state: RootState) => state.BookmarksState.bookmarks,
  getBookMarkPageLabels: (state: RootState) =>
    state.BookmarksState.bookmarkPageLabels,
};
